import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, GET_AMZ_PRODUCT_URL, GET_AMZ_TRN_TYPE_URL, PAGE_SIZE } from '../../common/constants';
import { formatDateOrder, formatTo0Decimal, formatTo2Decimal, isEmpty, isEmptyArray, isNotEmpty, isNullCheck, isZero } from '../../common/util.services';
import { getTransaction, getDuplicateCount, resolveDuplicate, syncTransaction, syncTransactionZeroValue, exportTrnData, deleteTransaction, saveTransactionData } from '../amazon.services';
import { Box, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import YesNoDialog from '../../../components/message-dialog/yes-no-dialog.component';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import ICheckbox from '../../../components/checkbox/i-checkbox.component';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import EditCellComponent from '../../costing/detail/edit-cell.component';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { PlayCircleOutline } from '@mui/icons-material';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

const AmazonTransaction = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  dayjs.extend(utc);
  dayjs.extend(timezone);
  let today = dayjs.tz(dayjs(), 'America/Los_Angeles');
  let startDate = today.subtract(1, 'day');
  const [transaction, setTransaction] = useState([{rowId: '', orderDate: 'Loading...', orderId: '', sale: 0, refund: 0}]);
  const [searchData, setSearchData] = useState<any>({status: ALL, zeroValue: false, diffFulfill: false, duplicate: false, searchText: '', product: ALL,
                                                     sorting: 'Date', type: ALL, startDate: startDate, endDate: today});
  const [duplicateCount, setDuplicateCount] = useState(0);
  const [showSyncMsg, setShowSyncMsg] = useState(false);
  const [rowId, setRowId] = useState();
  const [message, setMessage] = useState('');
  const [syncType, setSyncType] = useState('');
  const [cellLabel, setCellLabel] = useState('');
  const [cellValueRow, setCellValueRow] = useState<any>([]);
  const [openValue, setOpenValue] = useState(false);
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const columns: GridColDef[] = [
    { field: 'orderDate', headerName: 'Date', filterable: false, sortable: false, editable: false, width: 170,
      cellClassName: (params) => { return 'USA' !== params.row.country ? "PrdSaleNegative" : "" },
      renderCell: (params: any) =>  ('Loading...' === params.row.orderDate ? 'Loading...' : 
      <Tooltip title={params.row.country + ' - ' + params.row.marketPlace}
      PopperProps={popperProps}>{<Box>{formatDateOrder(params.row.orderDate)}</Box>}</Tooltip>)
    },
    { field: 'type', headerName: 'Type', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params: any) =>  (<Tooltip title={getTrnTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{params.row.type}</Box>}</Tooltip>)
    },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 85,
      cellClassName: (params) => { return 1 === params.row.sameOrder ? "PerfNegative" : "" }
    },
    { field: 'orderId', headerName: 'Order Id', filterable: false, sortable: false, editable: false, width: 165,
      renderCell: (params) => { return 19 === params.row.orderId.length ?
                                              (<Link to={'https://sellercentral.amazon.com/orders-v3/order/' + params.row.orderId} 
                                                target="_blank">{params.row.orderId}</Link>) : params.row.orderId}
    },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 125,
      renderCell: (params: any) =>  (<Tooltip title={getPrdTooltip(params.row)}
      PopperProps={popperProps}>{<Box>{getProduct(params.row.product)}</Box>}</Tooltip>)
    },
    { field: 'unitCount', headerName: 'Pack', filterable: false, sortable: false, editable: false, width: 50,
      cellClassName: (params) => { return nullCheckValue(params.row) ? 'PerfNegative' : '' }
    },
    { field: 'sale', headerName: 'Sale', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.sale * 1),
    },
    { field: 'refund', headerName: 'Refund', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.refund * 1),
    },
    { field: 'fulfillment', headerName: 'Fulfill', filterable: false, sortable: false, editable: false, width:65,
      cellClassName: (params) => { return getFulfillClassName(params.row) },
      renderCell: (params: any) =>  ('Loading...' === params.row.orderDate ? '' : <Tooltip title={getTooltip(params.row)}
      PopperProps={popperProps}>{formatTo2Decimal(params.row.fulfillment)}</Tooltip>)
    },
    { field: 'referral', headerName: 'Refer', filterable: false, sortable: false, editable: false, width: 65,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.referral * 1),
    },
    { field: 'other', headerName: 'Oth Fee', filterable: false, sortable: false, editable: false, width: 70,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.other * 1),
    },
    { field: 'totalFee', headerName: 'Total Fee', filterable: false, sortable: false, editable: false, width: 75,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.totalFee * 1),
    },
    { field: 'lfhCost', headerName: 'LFH Cost', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.lfhCost * 1),
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'othGain', headerName: 'Oth Gain', filterable: false, sortable: false, editable: false, width: 75,
      renderCell: (params: any) => 'Loading...' === params.row.orderDate ? '' : formatTo2Decimal(params.row.othGain * 1),
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'action', headerName: 'Actions', filterable: false, sortable: false, editable: false, width: 80,
      renderCell: (params: any) => (<Stack direction="row" spacing={-1} alignItems="center" justifyContent="center">
                                    <Tooltip title={'Delete Transaction'} PopperProps={popperProps}>
                                    <IconButton size="small" onClick={() => deleteTrn(params.row)}>
                                      <DeleteIcon fontSize="small" color='secondary'/></IconButton></Tooltip>
                                    <Tooltip title={'Resolve Duplicate'} PopperProps={popperProps}>
                                    <IconButton size="small" onClick={() => resolveDuplicateData(params.row)}>
                                      <CheckCircleOutlinedIcon fontSize="small" color='secondary'/></IconButton></Tooltip>
                                    <Tooltip title={'Sync Transaction'} PopperProps={popperProps}>
                                    <IconButton size="small" onClick={() => syncTransactionData(params.row)}>
                                      <PlayCircleOutline fontSize="small" color='secondary'/></IconButton></Tooltip>
                                    </Stack>)
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  function getProduct(value: any) {
    if(isNotEmpty(value)) {
      return value.split(',')[0];
    }
  }

  function nullCheckValue(row: any) {
    return (isNullCheck(row.unitCount) || isNullCheck(row.product) || isNullCheck(row.color) || isNullCheck(row.size)) && isNotEmpty(row.sku)
  }

  function getPrdTooltip(value: any) {
    if(isNotEmpty(value.product)) {
      let qty =  value.quantity;
      let size = value.size;
      let color = value.color;
      let sku = value.sku;

      let text = qty + ',' + color + ',' + size + ',' + sku;
      let array = text.split(',');
      array[0] = 'Quantity: ' + array[0];
      array[1] = 'Color: ' + array[1];
      array[2] = 'Size: ' + array[2];
      array[3] = 'SKU: ' + array[3];

      let newText = array.map(i => {
        return <p>{i}</p>
      });

      return newText;
    }
  }

  function getTransactionData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      let data = {type: searchData.type, zeroValue: searchData.zeroValue, 
                  sorting: 'Date' === searchData.sorting ? '&sort=orderDate,desc' : '&sort=orderId,desc&sort=sku,desc&sort=status,desc',
                  duplicate: searchData.duplicate, diffFulfill: searchData.diffFulfill, product: searchData.product,
                  startDate: searchData.startDate, endDate: searchData.endDate, 
                  searchText: searchData.searchText, status: searchData.status};
      getTransaction(data, page, pageSize, appContext,
        (response: any) => {
          setTransaction(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }

  function getTrnTooltip(row: any) {
    if('Other' !== row.type) {
      return row.type;
    }

    let type = row.trnType;
    let desc = row.description;

    let text = type + ',' + desc;
    let array = text.split(',');
    array[0] = 'Type: ' + array[0];
    array[1] = 'Desc: ' + array[1];

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getTooltip (row: any) {
    if(0 === row.fulfillment) {
      return formatTo2Decimal(row.fulfillment);
    }
    let quantity = row.quantity;
    let fulfill = formatTo2Decimal(-row.fulfillment/quantity);
    let invFulfill = isEmpty(row.invFulfillment) ? 'NA' : formatTo2Decimal(row.invFulfillment/quantity);
    let trnPct = formatTo2Decimal(fulfill * quantity * 100/row.sale);
    let invPct = formatTo2Decimal(invFulfill * quantity * 100/row.sale);

    let text = fulfill + ',' + invFulfill
    let array = text.split(',');
    array[0] = 'Trn Fulfill: ' + array[0] + ' (' + trnPct + '%)';
    array[1] = 'Inv Fulfill: ' + array[1] + ' (' + invPct + '%)';

    let newText = array.map(i => {
      return <p>{i}</p>
    });

    return newText;
  }

  function getDuplicateCountData() {
    if (isEmptyArray(rows)) {
      setLoading(true);
      getDuplicateCount(appContext,
        (response: any) => {
          setDuplicateCount(response.data);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }
  
  useEffect(() => {
    getTransactionData();
    getDuplicateCountData();
  }, [searchData, page, pageSize]);

  function getFulfillClassName(row: any) {
    let fulfill = -(isEmpty(row.fulfillment) ? 0 : row.fulfillment);
    let invFulfill = isEmpty(row.invFulfillment) ? 0 : row.invFulfillment;
    let type = row.type;
    let sale = row.sale;
    if('Order' === type && fulfill.toFixed(2) !== invFulfill.toFixed(2) && sale !== 0) {
      if(fulfill > invFulfill) {
        return 'PerfNegative';
      } else {
        return 'PerfPositive'
      }
    } else {
      return '';
    }
  }

  function getClassName(params: any) {
    let type = params.row.type;
    let lfhCost = params.row.lfhCost;
    let othGain = params.row.othGain;
    let totalFee = params.row.totalFee;
    let sale = params.row.sale;
    let refund = params.row.refund;
    let unitCount = params.row.unitCount;
    if('Order' === type && !isZero(sale) && (isZero(lfhCost) || isZero(unitCount) || isZero(othGain))) {
      return 'PerfNegative';
    } else if('Refund' === type && !isZero(refund) && (isZero(lfhCost) || isZero(unitCount) || isZero(othGain))) {
      return 'PerfNegative';
    } else if(('Inv Reimburse' === type || 'Liquidation' === type) && 
              (isZero(lfhCost) || isZero(unitCount)) && !isZero(totalFee)) {
      return 'PerfNegative';
    } else {
      return '';
    }
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const deleteTrn = (row: any) => {
    setSyncType('Delete');
    setRowId(row.rowId);
    setMessage('Do you want to delete the data?');
    setShowSyncMsg(true);
  }
  
  const resolveDuplicateData = (row: any) => {
    setSyncType('Duplicate');
    setRowId(row.rowId);
    setMessage('Do you want to resolve duplicate?');
    setShowSyncMsg(true);
  }

  const syncTransactionData = (row: any) => {
    setSyncType('Row');
    setRowId(row.rowId);
    setMessage('Do you want to sync the data?');
    setShowSyncMsg(true);
  };

  const syncZeroValue = (row: any) => {
    setSyncType('Zero Value');
    setMessage('Do you want to sync the data?');
    setShowSyncMsg(true);
  };

  const syncAllTransactionData = () => {
    setLoading(true);
    syncTransactionZeroValue(appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  }

  const onCellDoubleClick = (value: any) => {
    const field = value.field;
    if('sale' === field) {
      setCellValueRow(value.row);
      setCellLabel('Sale');
      openValuePopup();
    } else if('refund' === field) {
      setCellValueRow(value.row);
      setCellLabel('Refund');
      openValuePopup();
    } else if('lfhCost' === field) {
      setCellValueRow(value.row);
      setCellLabel('LFH Cost');
      openValuePopup();
    } else if('othGain' === field) {
      setCellValueRow(value.row);
      setCellLabel('Other Gain');
      openValuePopup();
    }
  }

  const openValuePopup = () => {
    setOpenValue(true);
  }

  const closeValuePopup = (value: any) => {
    if('Ok' === value) {
      setLoading(true);
      appContext.setShowLoader(true);
      saveTransactionData(cellValueRow, appContext,
        (response: any) => {
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
          setLoading(false);
          setOpenValue(false);
          getTransactionData();
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
          setLoading(false);
          setOpenValue(false);
      });
    } else {
      setOpenValue(false);
    }
  }

  const onOkClick = () => {
    if('Row' === syncType) {
      syncTransaction(rowId, appContext,
        (response: any) => {
          getTransactionData();
          getDuplicateCountData();
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    } else if('Zero Value' === syncType) {
      syncAllTransactionData();
    } else if('Delete' === syncType) {
      deleteTransaction(rowId, appContext,
      (response: any) => {
        getTransactionData();
        getDuplicateCountData();
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
    } else if('Duplicate' === syncType) {
      resolveDuplicate(rowId, appContext,
      (response: any) => {
        getTransactionData();
        getDuplicateCountData();
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
    }
  };

  const search = (data: any) => {
    setSearchData(data);
  }

  const onColumnHeaderClick = (value: any) => {
    const field = value.field;
    if(field === 'sale' || field === 'refund') {
      let sum = 0;
      for(let i = 0; i < transaction.length; ++i) {
        sum += field === 'sale' ? transaction[i].sale : transaction[i].refund;
      }
      appContext.setDialogMessage('Total Value = ' + formatTo0Decimal(sum));
    }
  }

  const saveExcel = (invData: any) => {
    let header = ["Date", "Type", "Status", "Order Id", "SKU", "Quantity", "Pack", "Sale", "Refund", 
                  "Fulfillment Fee", "Referral Fee", "Other Fee", "Total Fee", "LFH Cost", "Other Gain"];
    const excelSheet = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(excelSheet, [header]);
    XLSX.utils.sheet_add_json(excelSheet, invData, { origin: 'A2', skipHeader: true });
    const excelBook = { Sheets: { 'Transaction': excelSheet }, SheetNames: ['Transaction'] };
    const excelBuffer = XLSX.write(excelBook, { bookType: 'xlsx', type: 'array', cellStyles:true });
    const excelData = new Blob([excelBuffer], { type: 'xlsx' });
    FileSaver.saveAs(excelData, "Amazon_Transaction.xlsx");
  }

  const exportData = () => {
    exportTrnData(searchData, appContext,
      (response: any) => {
        saveExcel(response.data);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        setLoading(false);
      });
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData} export={exportData} showExportBtn={true}>
      <Grid container spacing={1} alignItems="center">
        <Grid xs={1}>
          <IDropdown name='status' label='Status' itemList={['Deferred', 'Released']} allItemRequired={true}/>
        </Grid>
        <Grid xs={1}>
          <IDropdown name='type' label='Type' url={GET_AMZ_TRN_TYPE_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='startDate' label='Start Date' timeZone='America/Los_Angeles'/>
        </Grid>
        <Grid xs={1.5}>
          <IDateField name='endDate' label='End Date' timeZone='America/Los_Angeles'/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true} />
        </Grid>
        <Grid xs={1.5}>
          <ITextField name='searchText' label='Search Text' />
        </Grid>
        <Grid xs={1}>
          <IDropdown name='sorting' label='Sorting' itemList={['Date', 'Order Id']} required={true} allItemRequired={false}/>
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='zeroValue' label='Zero Val' defaultChecked={false} />
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='duplicate' label='Duplicate' defaultChecked={false} />
        </Grid>
        <Grid xs={1}>
          <ICheckbox name='diffFulfill' label='Diff Fulfill' defaultChecked={false} />
        </Grid>
      </Grid>
    </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={transaction} columns={columns} loading={loading} showExtBtn={true} 
        extBtnText={'Sync Zero Value'} extBtnAction={syncZeroValue} onColumnHeaderClick={onColumnHeaderClick}
        showExtBtn2={false} extBtn2Text={'Export'} extBtn2Action={exportData}
        showExtraText={duplicateCount > 0} extraText={'Duplicate Transaction: ' + duplicateCount} 
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
        showAction={false} getRowId={(row: any) => row.rowId} maxHeight={450} cellDoubleClick={onCellDoubleClick}/>
      <YesNoDialog open={showSyncMsg} onClose={() => { setShowSyncMsg(false) }}
                onOk={() => { setShowSyncMsg(false); onOkClick(); }} isHorizontal={true} 
                message={message}/>
      <IDialogComponent onClose={closeValuePopup} open={openValue} title={'Specify Value'}
        dialogBody={<EditCellComponent data={cellValueRow} close={closeValuePopup} label={cellLabel}/>} />
    </>
  }

  return <TitlePanel title='Transaction' panelBody={getMainPanel()} />
}

export default AmazonTransaction;